"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFilterType = exports.LLM_FRAMEWORKS = exports.AIModelFrameworkMap = exports.AIModelFramework = exports.AppProjectTypeMap = exports.AppProjectType = exports.AIModelTaskMap = exports.AIModelTask = exports.AIModelCategoryMap = exports.AIModelCategory = exports.LinkStatusColorMap = exports.LinkStatusMap = exports.NamespaceStatus = exports.LinkStatus = exports.AppRegistrationMap = exports.AppRegistration = void 0;
var AppRegistration;
(function (AppRegistration) {
    AppRegistration["EXTERNAL_RESOURCE"] = "external-resource";
    AppRegistration["URI_REGISTRATION"] = "uri-registration";
    AppRegistration["TUNNEL_REGISTRATION"] = "tunnel-registration";
})(AppRegistration || (exports.AppRegistration = AppRegistration = {}));
exports.AppRegistrationMap = {
    [AppRegistration.EXTERNAL_RESOURCE]: 'External Resource',
    [AppRegistration.URI_REGISTRATION]: 'URI Registration',
    [AppRegistration.TUNNEL_REGISTRATION]: 'Tunnel Registration',
};
var LinkStatus;
(function (LinkStatus) {
    LinkStatus[LinkStatus["ONLINE"] = 1] = "ONLINE";
    LinkStatus[LinkStatus["OFFLINE"] = 2] = "OFFLINE";
    LinkStatus[LinkStatus["ERROR"] = 3] = "ERROR";
})(LinkStatus || (exports.LinkStatus = LinkStatus = {}));
var NamespaceStatus;
(function (NamespaceStatus) {
    NamespaceStatus["active"] = "active";
    NamespaceStatus["reserved"] = "reserved";
    NamespaceStatus["archived"] = "archived";
    NamespaceStatus["removed"] = "removed";
})(NamespaceStatus || (exports.NamespaceStatus = NamespaceStatus = {}));
exports.LinkStatusMap = {
    [LinkStatus.ONLINE]: 'Online',
    [LinkStatus.OFFLINE]: 'Offline',
    [LinkStatus.ERROR]: 'Error',
};
exports.LinkStatusColorMap = {
    [LinkStatus.ONLINE]: 'success',
    [LinkStatus.OFFLINE]: 'default',
    [LinkStatus.ERROR]: 'error',
};
var AIModelCategory;
(function (AIModelCategory) {
    AIModelCategory["LLM"] = "llm";
    AIModelCategory["CV"] = "cv";
    AIModelCategory["NLP"] = "nlp";
    AIModelCategory["Audio"] = "audio";
    AIModelCategory["MISC"] = "misc";
    AIModelCategory["OTHER"] = "other";
})(AIModelCategory || (exports.AIModelCategory = AIModelCategory = {}));
exports.AIModelCategoryMap = {
    [AIModelCategory.LLM]: 'LLM',
    [AIModelCategory.CV]: 'CV',
    [AIModelCategory.NLP]: 'NLP',
    [AIModelCategory.Audio]: 'Audio',
    [AIModelCategory.MISC]: 'Misc',
    [AIModelCategory.OTHER]: 'Other',
};
var AIModelTask;
(function (AIModelTask) {
    AIModelTask["Classification"] = "classification";
    AIModelTask["Detection"] = "detection";
    AIModelTask["Segmentation"] = "segmentation";
    AIModelTask["Generation"] = "generation";
    AIModelTask["Translation"] = "translation";
    AIModelTask["Summarization"] = "summarization";
    AIModelTask["Other"] = "other";
    AIModelTask["NamedEntityRecognition"] = "named-entity-recognition";
})(AIModelTask || (exports.AIModelTask = AIModelTask = {}));
exports.AIModelTaskMap = {
    [AIModelTask.Classification]: 'Classification',
    [AIModelTask.Detection]: 'Detection',
    [AIModelTask.Segmentation]: 'Segmentation',
    [AIModelTask.Generation]: 'Generation',
    [AIModelTask.Translation]: 'Translation',
    [AIModelTask.Summarization]: 'Summarization',
    [AIModelTask.NamedEntityRecognition]: 'Named Entity Recognition',
    [AIModelTask.Other]: 'Other',
};
var AppProjectType;
(function (AppProjectType) {
    AppProjectType["AI_MODEL"] = "ai-model";
    AppProjectType["WEB_APP"] = "web-app";
    AppProjectType["OTHER"] = "other";
    AppProjectType["COLAB"] = "colab";
    AppProjectType["REST_API"] = "rest-api";
})(AppProjectType || (exports.AppProjectType = AppProjectType = {}));
exports.AppProjectTypeMap = {
    [AppProjectType.AI_MODEL]: 'AI Model',
    [AppProjectType.WEB_APP]: 'Web App',
    [AppProjectType.COLAB]: 'Colab',
    [AppProjectType.REST_API]: 'REST API',
    [AppProjectType.OTHER]: 'Other',
};
var AIModelFramework;
(function (AIModelFramework) {
    AIModelFramework["Streamlit"] = "streamlit";
    AIModelFramework["Gradio"] = "gradio";
    AIModelFramework["Ollama"] = "ollama";
    AIModelFramework["VLLM"] = "vllm";
    AIModelFramework["LlamaCpp"] = "llamacpp";
    AIModelFramework["LMStudio"] = "lmstudio";
    AIModelFramework["LocalAI"] = "localai";
    AIModelFramework["TGI"] = "tgi";
})(AIModelFramework || (exports.AIModelFramework = AIModelFramework = {}));
exports.AIModelFrameworkMap = {
    [AIModelFramework.Streamlit]: 'Streamlit',
    [AIModelFramework.Gradio]: 'Gradio',
    [AIModelFramework.Ollama]: 'Ollama',
    [AIModelFramework.VLLM]: 'vLLM',
    [AIModelFramework.LlamaCpp]: 'llama.cpp',
    [AIModelFramework.LMStudio]: 'LM Studio',
    [AIModelFramework.LocalAI]: 'LocalAI',
    [AIModelFramework.TGI]: 'TGI',
};
exports.LLM_FRAMEWORKS = [
    AIModelFramework.Ollama,
    AIModelFramework.VLLM,
    AIModelFramework.LlamaCpp,
    AIModelFramework.LMStudio,
    AIModelFramework.LocalAI,
    AIModelFramework.TGI,
];
var AppFilterType;
(function (AppFilterType) {
    AppFilterType["ALL"] = "all";
    AppFilterType["MY_APPS"] = "my-apps";
    AppFilterType["MY_ORGANIZATION_APPS"] = "my-organization-apps";
    AppFilterType["CATALOG"] = "catalog";
    AppFilterType["FAVORITES"] = "favorites";
    AppFilterType["MOST_POPULAR"] = "most-popular";
    AppFilterType["RECENT"] = "recent";
    AppFilterType["ONLINE"] = "online";
    AppFilterType["OFFLINE"] = "offline";
    AppFilterType["ERROR"] = "error";
    AppFilterType["ARCHIVED"] = "archived";
    AppFilterType["RESERVED"] = "reserved";
    AppFilterType["REMOVED"] = "removed";
})(AppFilterType || (exports.AppFilterType = AppFilterType = {}));
